import React, { useState } from "react";

// Mismo patrón de pills ES/EN que el editor del blog (BlogForm.js).
const PILL_GROUP = "inline-flex items-center gap-1 rounded-full bg-gray-100 p-1";
const PILL_IDLE =
  "rounded-full px-4 py-1.5 text-sm text-gray-600 transition hover:text-[#1b4d2e]";
const PILL_ACTIVE =
  "rounded-full bg-[#1b4d2e] px-4 py-1.5 text-sm font-semibold text-white shadow-sm";

/**
 * Descripción del venue con selector de idioma Español | English.
 * ES escribe `description` (campo canónico existente); EN escribe
 * `descriptionEn` (opcional — los venues sin traducción simplemente no lo
 * tienen; el sitio público hará fallback a la descripción en español).
 */
export default function BilingualDescriptionField({
  valueEs = "",
  valueEn = "",
  onChangeEs,
  onChangeEn,
  rows = 6,
  label = "Descripción",
  nameEs = "description",
  nameEn = "descriptionEn",
  placeholderEs = "Descripción del venue (español)",
  placeholderEn = "Venue description (English) — se usa en la versión /en del sitio; si se deja vacía, se muestra la descripción en español",
}) {
  const [lang, setLang] = useState("es");
  const isEs = lang === "es";
  // Sin texto EN (o solo espacios) → la traducción sigue pendiente.
  const enPendiente = !(valueEn || "").trim();

  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <label className="block text-sm font-medium text-gray-700">
            {label}
          </label>
          {enPendiente && (
            <span
              className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-amber-800"
              title="Falta la traducción al inglés; el sitio público mostrará la descripción en español"
            >
              EN pendiente
            </span>
          )}
        </div>
        <div className={PILL_GROUP}>
          {[
            { key: "es", label: "Español" },
            { key: "en", label: "English" },
          ].map((l) => (
            <button
              key={l.key}
              type="button"
              onClick={() => setLang(l.key)}
              className={lang === l.key ? PILL_ACTIVE : PILL_IDLE}
            >
              {l.label}
              {l.key === "en" && enPendiente && " (sin traducir)"}
            </button>
          ))}
        </div>
      </div>
      <textarea
        name={isEs ? nameEs : nameEn}
        value={isEs ? valueEs : valueEn}
        onChange={(e) =>
          isEs ? onChangeEs(e.target.value) : onChangeEn(e.target.value)
        }
        placeholder={isEs ? placeholderEs : placeholderEn}
        rows={rows}
        className="w-full border p-2 rounded"
      />
      {!isEs && (
        <p className="mt-1 text-xs text-gray-500">
          Esta traducción se mostrará en la versión en inglés del sitio público
          cuando esté disponible.
        </p>
      )}
    </div>
  );
}
